// Basic validation functions
export const isRequired = (value) => {
  if (value === null || value === undefined) return false;
  return value.toString().trim().length > 0;
};

export const isEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export const isPhoneNumber = (phone) => {
  const re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return re.test(String(phone));
};

export const isZipCode = (zip) => {
  const re = /^\d{5}(-\d{4})?$/;
  return re.test(String(zip));
};

export const isLoanNumber = (loan) => {
  return /^[a-zA-Z0-9-]{4,30}$/.test(String(loan));
};

export const isPolicyNumber = (policy) => {
  if (policy === null || policy === undefined) {
    return false;
  }
  const policyStr = String(policy).trim();
  return policyStr.length >= 3;
};

// Exported validation functions that combine the basic validators
export const validateEmail = (email) => {
  if (!isRequired(email)) return 'Email is required';
  if (!isEmail(email)) return 'Please enter a valid email address';
  return '';
};

export const validatePhoneNumber = (phone) => {
  if (!isRequired(phone)) return 'Phone number is required';
  if (!isPhoneNumber(phone)) return 'Please enter a valid phone number';
  return '';
};

export const validatePolicyNumber = (policy) => {
  if (!isRequired(policy)) return 'Policy number is required';
  if (!isPolicyNumber(policy)) return 'Policy number must be at least 3 characters long.';
  return '';
};

export const validateZipCode = (zip) => {
  if (!isRequired(zip)) return 'ZIP code is required';
  if (!isZipCode(zip)) return 'Please enter a valid ZIP code';
  return '';
};

export const validateMortgageeForm = (formData) => {
  const errors = {};

  if (!isRequired(formData.mortgageeAction)) {
    errors.mortgageeAction = 'Please select a mortgagee action';
  }

  if (formData.mortgageeAction !== 'remove') {
    if (!isRequired(formData.mortgageeName)) {
      errors.mortgageeName = 'Mortgagee name is required';
    }

    if (!isRequired(formData.loanNumber)) {
      errors.loanNumber = 'Loan number is required';
    } else if (!isLoanNumber(formData.loanNumber)) {
      errors.loanNumber = 'Please enter a valid loan number';
    }

    if (!isRequired(formData.mortgageeAddress)) {
      errors.mortgageeAddress = 'Street address is required';
    }

    if (!isRequired(formData.mortgageeCity)) {
      errors.mortgageeCity = 'City is required';
    }

    if (!isRequired(formData.mortgageeState)) {
      errors.mortgageeState = 'State is required';
    }

    if (!isRequired(formData.mortgageeZip)) {
      errors.mortgageeZip = 'ZIP code is required';
    } else if (!isZipCode(formData.mortgageeZip)) {
      errors.mortgageeZip = 'Please enter a valid ZIP code';
    }
  } else {
    if (!isRequired(formData.removalReason)) {
      errors.removalReason = 'Please select a reason for removal';
    }
  }

  return errors;
}; 